/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from './CompanyDetailsDto';
export type ExtendedProductFormulationAnnualReportDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    eventType: ExtendedProductFormulationAnnualReportDto.eventType;
    readonly performedBy?: ExtendedProductFormulationAnnualReportDto.performedBy;
    eventAt: string;
    readonly windowEnd?: string;
    readonly clientDetails?: CompanyDetailsDto;
    readonly supplierDetails?: CompanyDetailsDto;
    readonly productName?: string;
    readonly formulation?: string;
    readonly operatingFluidType?: string;
    readonly sheetNumbers?: Array<string>;
};
export namespace ExtendedProductFormulationAnnualReportDto {
    export enum eventType {
        EXTENDED = 'EXTENDED',
        NOT_EXTENDED = 'NOT_EXTENDED',
        OVERDUE = 'OVERDUE',
    }
    export enum performedBy {
        SYSTEM = 'SYSTEM',
        MERCEDES_BENZ = 'MERCEDES_BENZ',
        USER = 'USER',
    }
}

